import { MainInfo, WrapperMainInfoProps } from './main-info';
import withEvents from 'analytics/withEvents';


const MainInfoWithEvents = withEvents<WrapperMainInfoProps>(sendEvent => ({
  sendPriceEstimationClickEvent() {
    sendEvent('property_estimation_click', 'property');
  },
}))(MainInfo);

export default MainInfoWithEvents;
